import { render } from "./CheckProductSearchTab.vue?vue&type=template&id=6fc6b8b7"
import script from "./CheckProductSearchTab.vue?vue&type=script&lang=js"
export * from "./CheckProductSearchTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__